import apiClient from './apiClient';

// Public, non-secret platform config the SPA reads at boot (no auth):
// GET /api/v1/settings/public → { defaults, features }. Used to gate UI and seed
// sensible defaults before the user is known. Never exposes secrets.

export interface PublicDefaults {
  default_voice?: string | null;
  default_theme?: string | null;
  default_ai_model?: string | null;
  tts_provider?: string | null;
  tts_model?: string | null;
  platform_name?: string | null;
}

export interface PublicSettings {
  defaults: PublicDefaults;
  // Resolved feature-flag set: { 'ai_explain': true, 'virtual_lab': false, ... }
  features: Record<string, boolean>;
}

export async function getPublicSettings(): Promise<PublicSettings> {
  const { data } = await apiClient.get<PublicSettings>('/api/v1/settings/public');
  return {
    defaults: data.defaults ?? {},
    features: data.features ?? {},
  };
}
